var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwiseBlackOnWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1489,
    height: 454,
    viewBox: "0 0 1489 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.726 124C227.46 124 268.778 174.981 271.618 240.731L197.218 256.352C187.421 205.797 165.697 189.892 134.886 189.892C109.329 189.892 87.4629 201.11 87.4629 219.998C87.4629 236.329 97.1179 242.577 146.671 253.511C227.46 270.836 273.748 295.83 274.458 348.373C274.458 412.277 215.108 454.453 138.578 454.453C56.2262 454.453 7.80919 403.898 0 331.19L71.5606 315.711C85.6171 361.722 100.384 387.425 154.196 387.425C181.741 387.425 197.928 370.952 197.928 353.485C197.928 332.326 170.95 331.474 113.02 315.427C48.701 297.108 14.0565 267.712 14.0565 227.95C14.0565 160.78 59.3498 124 137.584 124H137.726Z",
    fill: "url(#paint0_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.827 130.363L474.724 447.184H398.478L452.291 130.363H527.969H527.827Z",
    fill: "url(#paint1_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.577 447.184H510.751L452.821 130.363H532.475L585.577 447.184Z",
    fill: "url(#paint2_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 80H721V0H805V80Z",
    fill: "url(#paint3_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.962 446.821H725V130H800.962V446.821Z",
    fill: "url(#paint4_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.868 117C1064.6 117 1105.92 167.981 1108.76 233.731L1034.36 249.352C1024.56 198.797 1002.84 182.892 972.028 182.892C946.468 182.892 924.463 194.11 924.463 212.998C924.463 229.329 934.117 235.577 983.668 246.511C1064.32 263.836 1110.75 288.83 1111.46 341.373C1111.46 405.277 1052.11 447.453 975.578 447.453C893.226 447.453 844.809 396.898 837 324.19L908.56 308.711C922.617 354.722 937.383 380.425 991.198 380.425C1018.74 380.425 1034.93 363.952 1034.93 346.485C1034.93 325.326 1007.95 324.474 950.018 308.427C885.701 290.108 851.198 260.712 851.198 220.95C851.198 153.78 896.491 117 974.728 117H974.868Z",
    fill: "url(#paint5_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.74 255.352C1375.74 214.311 1340.67 189.034 1298.92 189.034C1262.15 189.034 1225.66 214.453 1225.66 255.352H1375.74ZM1308.72 383.301C1321.07 383.301 1360.97 380.745 1375.6 341.835L1449.85 353.905C1435.09 424.625 1377.02 453.595 1306.45 453.595C1197.26 453.595 1147 373.076 1147 288.724C1147 163.614 1236.45 123 1306.59 123C1419.47 123 1457.24 215.447 1457.24 296.108C1457.24 304.912 1456.81 313.575 1455.96 321.953H1226.65C1232.62 353.763 1253.77 383.443 1308.72 383.443V383.301Z",
    fill: "url(#paint6_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.478 447.184H351.93L294 130.363H373.086L425.478 447.184Z",
    fill: "url(#paint7_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.208 446.821H559.518L613.33 130H689.009L633.208 446.821Z",
    fill: "url(#paint8_linear_1_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4",
    x1: 0,
    y1: 289.227,
    x2: 274.458,
    y2: 289.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4",
    x1: 398.478,
    y1: 288.774,
    x2: 527.969,
    y2: 288.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4",
    x1: 452.821,
    y1: 288.774,
    x2: 585.577,
    y2: 288.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#649A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_4",
    x1: 721,
    y1: 40,
    x2: 805,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_4",
    x1: 725,
    y1: 288.411,
    x2: 800.962,
    y2: 288.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_4",
    x1: 837,
    y1: 282.227,
    x2: 1111.46,
    y2: 282.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_4",
    x1: 1225.66,
    y1: 222.193,
    x2: 1375.74,
    y2: 222.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_4",
    x1: 294,
    y1: 288.774,
    x2: 425.478,
    y2: 288.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#649A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_4",
    x1: 559.518,
    y1: 288.41,
    x2: 689.009,
    y2: 288.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548235"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1489,
    height: 454,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiseBlackOnWhite);
export default __webpack_public_path__ + "static/media/swise_black_on_white.172988cd553396ac3457128ab290283f.svg";
export { ForwardRef as ReactComponent };